import { render, staticRenderFns } from "./project2.vue?vue&type=template&id=3b627fd1"
import script from "./project2.vue?vue&type=script&lang=js"
export * from "./project2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports